import React from 'react';
import { useIntl } from 'react-intl';

import useBulkSelection from 'modules/menu/bulk-actions/useBulkSelection';

import { OptionBindingsModal } from './OptionBindingsModal';

type Props = {
  isOpen: boolean;
  loading?: boolean;
  onClose: () => void;
  onAddOptionBindings: (selectedOptionIds: Set<string>) => Promise<void>;
};

export const AddOptionsToItem = ({ isOpen, loading, onClose, onAddOptionBindings }: Props) => {
  const intl = useIntl();

  const {
    selectedIds: selectedOptionIds,
    select: selectOption,
    deselect: deselectOption,
    clearSelection: clearOptionSelection,
  } = useBulkSelection();

  const handleDone = async () => {
    await onAddOptionBindings(selectedOptionIds);
    clearOptionSelection();
  };

  const handleClose = () => {
    onClose();
    clearOptionSelection();
  };

  return (
    <OptionBindingsModal
      loading={loading}
      onClose={handleClose}
      onDeselectOption={deselectOption}
      onSelectOption={selectOption}
      isOpen={isOpen}
      onDone={handleDone}
      selectedOptionIds={selectedOptionIds}
      title={intl.formatMessage({ id: 'menu-item.addOptionsHeader' })}
    />
  );
};
